import React from 'react';
import { InlineWidget } from 'react-calendly';
import { companyInfo } from '../mock';

const BookingPage = () => {
  return (
    <div className="pt-48 pb-20 px-6">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-4xl md:text-6xl font-extrabold text-white mb-6 tracking-tight italic">
          Secure Your Slot
        </h2>
        <p className="text-gray-400 text-xl mb-12">
          Pick a time that works for you to build your growth system audit.
        </p>

        <div className="rounded-2xl overflow-hidden">
          <InlineWidget
            url={companyInfo.calendlyLink}
            styles={{
              height: '700px',
              minWidth: '320px'
            }}
            pageSettings={{
              backgroundColor: 'ffffff',
              hideEventTypeDetails: false,
              hideLandingPageDetails: false,
              primaryColor: '3B82F6',
              textColor: '020617'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingPage;
